import { render, staticRenderFns } from "./CreateOrganizationUser.vue?vue&type=template&id=b4cdfb34&"
import script from "./CreateOrganizationUser.vue?vue&type=script&lang=js&"
export * from "./CreateOrganizationUser.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrganizationUser.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports